import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTenant } from '../contexts/TenantContext';

const TenantGuard = ({ children }) => {
  const { tenant_id } = useParams();
  const navigate = useNavigate();
  const { selectedTenantId, tenantData } = useTenant();

  useEffect(() => {
    console.log('TenantGuard: tenant_id from URL:', tenant_id);
    console.log('TenantGuard: selectedTenantId from context:', selectedTenantId);
    console.log('TenantGuard: tenantData from context:', tenantData);

    const token = localStorage.getItem('access_token');

    if (!token) {
      console.warn('TenantGuard:User is not logged in. Redirecting to login page.');
      const loginPath = tenantData?.subdomain_prefix
        ? `/${tenantData.subdomain_prefix}/login`
        : '/login'; // Fallback to a generic login page if tenantData is undefined
      navigate(loginPath, { replace: true });
      return;
    }

    if (tenant_id !== tenantData?.subdomain_prefix) {
      console.warn(
        `TenantGuard: Mismatched tenant_id in URI. Expected: ${tenantData?.subdomain_prefix}, Found: ${tenant_id}`
      );
      const dashboardPath = tenantData?.subdomain_prefix
        ? `/app/${tenantData.subdomain_prefix}/dashboard`
        : '/dashboard'; // Fallback to a generic dashboard if tenantData is undefined
      navigate(dashboardPath);
    }
  }, [tenant_id, tenantData, navigate]);
  
  return <>{children}</>;
};

export default TenantGuard;
